import { Subscription } from 'rxjs/Subscription';
//Angular
import { Component, OnInit, ViewContainerRef, Compiler, Inject, Renderer } from "@angular/core";
import { Router, ActivatedRoute} from "@angular/router";

//Models
import { Category } from "./../../../../models/inventory/inventory";
import { SeoViewModel } from "./../../../../models/core/seo";
import { Breadcrumbs } from "./../../../../models/cms/breadcrumbs";
//Services
import { CategoryService } from "./../../../../services/inventory/category.service";
import { LanguageService } from "./../../../../services/cms/language.service";
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { ShoppingCartService } from "./../../../../services/inventory/shopping-cart.service";
import { BootboxService } from './../../../../services/core/bootbox.service';
import { SeoService } from "./../../../../services/core/seo.service";
import { RoutesService } from "./../../../../services/core/routes.service";
import { ScriptService } from "./../../../../services/cms/script.service";
import { HelperService } from "./../../../../services/core/helper.service";
import { CategoryInfoRequest } from "../../../../models/inventory/category-info-request";
import { Configuration } from "../../../../models/core/configuration";
import { BreadcrumbsService } from "../../../../services/cms/breadcrumbs.service";
import { DOCUMENT } from '@angular/platform-browser';

@Component({
    template: ""
})

export class CategoryComponent implements OnInit 
{
    category: Category = new Category();

    constructor
    (
        private _compiler: Compiler,
        private _elementRef: ViewContainerRef,
        private componentHelper: ComponentHelperService,
        private categoryService: CategoryService,
        private languageService: LanguageService,
        private route: ActivatedRoute,
        private router: Router,
        @Inject('isBrowser') private isBrowser: boolean,
        private seo: SeoService,
        private renderer: Renderer,
        @Inject(DOCUMENT) private document: any,
        private scriptService: ScriptService
        ){this.router.routeReuseStrategy.shouldReuseRoute = () => false; }

    subManager = new Subscription();

    ngOnInit() 
    {
        //Reading Language information
        let lang: string = this.languageService.getLongLang();

        //Reading id from url
        //If id is set, then the information is retrived by id, else by url
        let paramSub = this.route.params.subscribe(params => 
        {
            let id = params['id'];

            if (id !== undefined) 
            {
                let categoryId: number = id;

                let catIdSub = this.categoryService.getCategory(categoryId, lang).subscribe(result => 
                {
                     if (result.SeoInformation) {
                        result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                        result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
                    }
                    
                    
                    if (this.isBrowser) {
                        this.onGetCategorySuccess(result);
                    }
                    else {
                        //-- Get head and body scripts
                        this.scriptService.setupExternalScripts(result, this.scriptService.typeCatalogCategory, categoryId);

                        //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                        this.seo.setSeoMetaData(this.document, this.renderer, result.SeoInformation)
                        this.seo.generateSeoDomServerSide(this.document, this.renderer, result.SeoInformation);
                    }
                });

                this.subManager.add(catIdSub);
            }
            else 
            {
                let seoUrl = this.router.url;
                let catUrlSub = this.categoryService.getCategoryByUrl(lang, seoUrl).subscribe(result => 
                {
                    if (this.isBrowser) {
                        this.onGetCategorySuccess(result);
                    }
                    else {
                        //-- Get head and body scripts
                        this.scriptService.setupExternalScripts(result, this.scriptService.typeCatalogCategory, result.Id);

                        //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                        this.seo.setSeoMetaData(this.document, this.renderer, result.SeoInformation)
                        this.seo.generateSeoDomServerSide(this.document, this.renderer, result.SeoInformation);
                    }
                });

                this.subManager.add(catUrlSub);
            }
        });

        this.subManager.add(paramSub);
    }

    ngOnDestroy() 
    {
        this.subManager.unsubscribe();
    }

    onGetCategorySuccess(categoryResult: Category) 
    {
        if(categoryResult.Active != true)
        {
            //Creating sub-component with the returned information
            let subComponent = this.createSubComponentRedirect();
        
            //Injecting dynamically created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);                 
        }
        else
        {
            //Creating sub-component with the returned information
            let subComponent = this.createSubComponent(categoryResult);
        
            //Injecting dynamically created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        }
    }
    
    
    private createSubComponentRedirect()
    {
        @Component({
            template: ""
        })

        class ChildComponent implements OnInit 
        {
            constructor
            (
                private router: Router, 
                private routeService: RoutesService
            ) {}

            ngOnInit(): void 
            {
                let notFoundPage = this.routeService.getRoutePath('NOT - FOUND');
                this.router.navigate(notFoundPage);               
            }
        }

        return ChildComponent;
    }


    private createSubComponent(categoryObj: Category) 
    {
        @Component({
            template: categoryObj.TemplateHtml
        })

        class ChildComponent implements OnInit 
        {
            category: Category = categoryObj;
            categories: any = categoryObj.SubCategories;
            products: any = categoryObj.SubProducts;

            private loginPageName: string[] = [];
            private registerPageName: string[] = [];
          
            private pageIsInit: boolean = false;
            private seoInfo: SeoViewModel = categoryObj.SeoInformation;
            private spinnerForm: boolean = false;
            private contactFormSent: boolean = false;
            private contactFormFailed: boolean = false;
            private showSpinner: boolean = true;
            private showTable: boolean = true;

            private model: CategoryInfoRequest = {
                Company: "",
                Name: "",
                Lastname: "",
                Email: "",
                Amount: "",
                Mobile: "",
                Message: "",
                Lang:"",
                options:0
            }

            private configuration: Configuration;
            private lang: string = this.languageService.getLongLang();
            
            private breadcrumbs : Breadcrumbs[]=[];

            constructor
            (
                private seoService: SeoService, 
                private cartService: ShoppingCartService,
                private bootboxService: BootboxService,
                private routeService: RoutesService,
                @Inject('isBrowser') private isBrowser: boolean,
                private scriptService: ScriptService,
                private _elementRef: ViewContainerRef,
                private helperService: HelperService,
                private categoryService: CategoryService,
                private languageService: LanguageService,
                private breadcrumbsService: BreadcrumbsService
            ) {}

            subManager = new Subscription();
            
            ngOnInit()
            {   
                //setting new breadcrumbs, setTimeout must be called because it is initializating new event, in opposite, app is crashed
                this.breadcrumbs = categoryObj.BreadcrumbsInfo;
                setTimeout(x => this.breadcrumbsService.setBreadcrumbs(this.breadcrumbs), 1);

                this.loginPageName = this.routeService.getRoutePath('LOGIN');
                this.registerPageName = this.routeService.getRoutePath('REGISTRAZIONE');
                               
                this.configuration = categoryObj.Configuration;
                if(this.isBrowser == true)
                {
                    //if type of category is matrix, get prices
                    if (categoryObj.TipoVisualizzazione == "matrice")
                    {
                        let catPriceSub = this.categoryService.getCategoryPriceData(categoryObj.Id)
                        .subscribe(result => 
                        {
                            this.category.PriceData = result;
                            this.showSpinner = false; 
                        })

                        this.subManager.add(catPriceSub);
                    }
                }
            }
            
            onSubmit(form)
            {
                this.contactFormSent = false;
                this.contactFormFailed = false;                
                this.spinnerForm = true;
                this.model.Lang = this.languageService.getLongLang();

                if(form.valid && this.model.options == 1)
                {
                    this.model.Amount = this.model.Amount.toString();                    
                    let catInfoSub = this.categoryService.getCategoryInfo(this.model)
                        .subscribe(result => 
                        {
                            if(result == true)
                            {
                                this.spinnerForm = false;
                                this.contactFormSent = true;
                            }
                            else
                            {
                                this.spinnerForm = false;
                                this.contactFormFailed = true;
                            }
                        })

                        this.subManager.add(catInfoSub);
                }
                else
                {
                    this.spinnerForm = false;
                }
            }
            showedFileBoxWizard()
            {
                let result: boolean = true;
                if( this.category.IdWizardMaster <= 0)
                {
                    result = false;
                }
                else   
                {
                    if(this.category.ManageAttachmentWizard=="Combinazioni")
                    {
                        result = false; 
                    }
                }
               
                return result;
            }
            addMatrixCommercialeProductToCart(productId: number, quantityId: number) 
            {
                let addToCartSub = this.cartService.addMatrixProductToCart(productId, quantityId, "altro").subscribe(result => 
                {
                    this.cartService.updateCart(result);

                    this.bootboxService.i18nAlert("productAddedToCart");
                },
                    err => 
                    {
                        this.bootboxService.i18nAlert("errorMex");
                    }
                );

                this.subManager.add(addToCartSub);
            }            

            addMatrixEditoriaProductToCart(productId: number, quantityId: number) 
            {
                let addMatEdToCartSub = this.cartService.addMatrixProductToCart(productId, quantityId, "editoria").subscribe(result => 
                {
                    this.cartService.updateCart(result);
                    this.bootboxService.i18nAlert("productAddedToCart");
                },
                    err => 
                    {
                        this.bootboxService.i18nAlert("errorMex");
                    }
                );

                this.subManager.add(addMatEdToCartSub);
            }

            addMatrixProductToCart(productId: number, quantityId: number) 
            {
                let addMatToCartSub = this.cartService.addMatrixProductToCart(productId, quantityId, "altro").subscribe(result => 
                {
                    this.cartService.updateCart(result);
                    this.bootboxService.i18nAlert("productAddedToCart");
                },
                    err => 
                    {
                        this.bootboxService.i18nAlert("errorMex");
                    }
                );

                this.subManager.add(addMatToCartSub);
            }            
                    
            ngAfterViewChecked() 
            {
                if (!this.isBrowser || this.pageIsInit) 
                {
                    return;
                }

                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);       

                //hiding of loading panel after we get all data we need
                this.routeService.hidePageLoader();

                layoutTheme.initCarousel();
                layoutTheme.initLightbox();

                $('.popovers').popover();        

                this.pageIsInit = true;
            }   
            
            imageTitle(imgPath)
            {
                let imgName = this.helperService.GetFileNameFromPath(imgPath);
                return imgName;
            }

            ngOnDestroy() {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            }
        }

        return ChildComponent;
    }
}



// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/inventory/category/sys/category.component.ts